import TableTextCell from '../../components/common/Table/TableTextCell';
import TableHeaderCell from '../../components/common/Table/TableHeaderCell';
import { useRequestorStore } from '../../stores/requestorStore';
import { IRequestInfo } from '../../types/requester';
import { getDateAndTime } from '../../utils/commonUtils';
import { useVendorStore } from '../../stores/vendorStore';
import { FileValidationReport, getSizeInMb, ValidationErrorType } from '../../utils/file';
import StageCell from '../../components/common/Table/StageCell';
import { TextureConstants } from '../../utils/constants';

const BulkUploadStatus = () => {
    const activeRequest: IRequestInfo | null = useRequestorStore((state) => state.activeRequest);
    const uploadedModels: PromiseFulfilledResult<FileValidationReport>[] = useVendorStore((state) => state.uploadedModels);

    const inValidModels = uploadedModels.filter((model) => (model as PromiseFulfilledResult<FileValidationReport>).value.report?.valid === false);
    const successColorCode: string = '#89C286';
    const failureColorCode: string = '#F87171';
    const headerData = ['File Name', 'Status', 'Reason', 'Last Modified At', 'Size'];

    const getErrorType = (error: any): string => {
        if (!error?.valid) {
            let errorType: any = ValidationErrorType.SOMETHING_WENT_WRONG;
            if (typeof error === 'string') {
                errorType = error;
            } else if (error?.valid === false && error?.errorType === ValidationErrorType.SIZE_EXCEEDED) {
                errorType = 'Exceeds 8 MB limit';
            } else if (error?.valid === false && error?.errorType === ValidationErrorType.HAS_DRACO_COMPRESSION) {
                errorType = 'File has Draco Compression';
            } else if (error?.valid === false && error?.errorType === ValidationErrorType.TEXTURE_SIZE_EXCEEDED) {
                errorType = `Exceeds ${TextureConstants.Length} x ${TextureConstants.Width} texture limit`;
            } else if (error?.response?.status < 500) {
                errorType = error?.response?.data?.message;
            }
            return errorType;
        } else {
            return '-';
        }
    };

    return (
        <div className="container mx-auto p-8" id="section-to-print">
            <div className="flex flex-row sm:mb-0 justify-between w-full">
                <h2 className="text-xl font-semibold text-black ">
                    Bulk Upload Status - <span className={inValidModels.length ? 'text-red-400' : ' text-approved-green '}> {inValidModels.length ? 'Failed' : 'Success'} </span>
                </h2>
                <button
                    id="ignore-print"
                    onClick={window.print}
                    className=" py-2 px-4 flex justify-center 
            items-center 
            bg--700 hover:bg--900
             border border-gray-700 text-base font-semibold shadow-md focus:outline-none rounded-md"
                    type="submit"
                >
                    Print Report
                </button>
            </div>
            <div className="my-10 grid grid-cols-2 ">
                <div className="flex mb-2 flex-1 ">
                    <div className="text-gray-500 whitespace-no-wrap text-base capitalize w-36">Request ID</div>:
                    <div className="text-gray-900 whitespace-no-wrap text-base capitalize w-36 text-right">{activeRequest?.id}</div>
                </div>
                <div className="flex mb-2 flex-1">
                    <div className="text-gray-500 whitespace-no-wrap text-base capitalize w-36">Total Files</div>:
                    <div className="text-gray-900 whitespace-no-wrap text-base capitalize w-36 text-right">{uploadedModels?.length} </div>
                </div>
                <div className="flex mb-2">
                    <div className="text-gray-500 whitespace-no-wrap text-base capitalize w-36">Valid Files</div>:
                    <div className="text-gray-900 whitespace-no-wrap text-base capitalize w-36 text-right">{uploadedModels.length - inValidModels.length}</div>
                </div>
                <div className="flex mb-2">
                    <div className="text-gray-500 whitespace-no-wrap text-base capitalize w-36">Invalid Files</div>:
                    <div className="text-gray-900 whitespace-no-wrap text-base capitalize w-36 text-right">{inValidModels.length} </div>
                </div>
            </div>
            {uploadedModels.length > 0 && (
                <div className="mx-auto mt-16">
                    <div className="py-8">
                        <div className="flex flex-row mb-1 sm:mb-0 justify-between w-full ">
                            <h2 className="text-xl font-semibold text-black">Upload Status</h2>
                        </div>
                        <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
                            <div className="inline-block min-w-full shadow-sm rounded-lg overflow-hidden">
                                <table className="min-w-full leading-normal table-auto">
                                    <thead>
                                        <tr>
                                            {headerData?.map((title) => (
                                                <TableHeaderCell label={title} />
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {uploadedModels.map(({ status, value: { name, time, size, report } }) => (
                                            <tr>
                                                <TableTextCell dataLabel={headerData[0]} label={name} />
                                                <StageCell dataLabel={headerData[1]} title={report?.valid ? 'Uploaded' : 'Failed'} activeColor={report?.valid ? successColorCode : failureColorCode} />

                                                <TableTextCell dataLabel={headerData[2]} label={getErrorType(report)} />
                                                <TableTextCell dataLabel={headerData[3]} label={getDateAndTime(time || null)} />

                                                <TableTextCell dataLabel={headerData[4]} label={getSizeInMb(size || 0)} />
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BulkUploadStatus;
